module.exports = __webpack_public_path__ + "d1f4dd8082a522c1.svg";